/** Trend direction, decoupled from `aos-helpers`' `Trend` enum. */
export type TrendDirection = 'up' | 'down' | 'flat'

/** Which direction counts as good — drives the arrow colour, not its shape. */
export type TrendPreference = 'up' | 'down'

export type TrendMeasureSize = 'regular' | 'small'

export interface ResolvedTrendIcon {
    direction: 'up' | 'down'
    tone: 'success' | 'critical'
}

/**
 * A flat trend renders no arrow. Otherwise the arrow points the way the value
 * moved and is coloured by whether that movement is the preferred one.
 */
export const resolveTrendIcon = (
    direction: TrendDirection,
    preference: TrendPreference = 'up',
): ResolvedTrendIcon | null => {
    if (direction === 'flat') {
        return null
    }
    return { direction, tone: direction === preference ? 'success' : 'critical' }
}
